import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import Home from './Home';
import University from "./university";

function Universities() {
    return (
        <main className="universities">
            <Router>
                <Switch>
                    <Route path="/dashboard/universities/home">
                        <Home />
                    </Route>
                    <Redirect strict exact from="/dashboard/universities/:id/" to="/dashboard/universities/:id" />
                    <Route path="/dashboard/universities/:id">
                        <University />
                    </Route>
                    <Route exact path="/dashboard/universities" render={() => <Redirect to="/dashboard/universities/home" />} />
                </Switch>
            </Router>
        </main>
    )
}

export default Universities